import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppPulseButton = () => {
  return (
    <a
      href="https://wa.me/916388414242"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-pulse-btn"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={24} />
    </a>
  );
};

export default WhatsAppPulseButton;
